import { Span } from '@pcln/horizon'
import { SearchFormRadioGroup } from '@pcln/horizon-search-form'

type FormTypeRadios = {
  formType: string
  onChange: (selectedFormName: string) => void
}

const isString = (value: unknown): value is string => {
  return typeof value === 'string'
}

export default function FormTypeRadios({ formType, onChange }: FormTypeRadios) {
  const handleChange = (value: unknown) => {
    if (isString(value)) {
      onChange(value)
    }
  }

  return (
    <SearchFormRadioGroup
      aria-labelledby='hotel-search-type'
      defaultValue={formType}
      handleChange={handleChange}
      name='hotelSearchType'
      options={[
        {
          disabled: false,
          labelNode: <Span className='whitespace-nowrap'>Single Hotel</Span>,
          size: '16',
          value: 'single',
        },
        {
          disabled: false,
          labelNode: <Span className='whitespace-nowrap'>Multi Hotel</Span>,
          size: '16',
          value: 'multi',
        },
      ]}
    />
  )
}
